import {createSlice} from '@reduxjs/toolkit';
import {
  updateWorkspaceLocationPreferences,
  updateParkingLocationPreferences,
  loadPreferences,
  dismissParkingIntroduction,
  dismissParkingSuggestionPopUp,
  updateLicensePlate,
  updateLicensePlates,
  updateThreeDMapsPreferred,
} from './actions';
import {initialState} from './initialState';

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPreferences.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loadPreferences.fulfilled, (state, action) => {
        state.isLoading = false;
        state.preferences = action.payload;
        state.isInitialized = true;
      });

    builder
      .addCase(updateWorkspaceLocationPreferences.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(updateWorkspaceLocationPreferences.fulfilled, (state, action) => {
        state.isSaving = false;
        state.preferences.workspaceLocation = action.payload;
      })
      .addCase(updateWorkspaceLocationPreferences.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.error.message || 'Failed to update workspace preferences';
      });

    builder
      .addCase(updateParkingLocationPreferences.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(updateParkingLocationPreferences.fulfilled, (state, action) => {
        state.isSaving = false;
        state.preferences.parkingLocation = action.payload;
      })
      .addCase(updateParkingLocationPreferences.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.error.message || 'Failed to update parking preferences';
      });

    // Parking
    builder
      .addCase(dismissParkingSuggestionPopUp.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(dismissParkingSuggestionPopUp.fulfilled, (state) => {
        state.preferences.userDismissedParkingSuggestionPopUp = true;
        state.isSaving = false;
      })
      .addCase(dismissParkingIntroduction.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(dismissParkingIntroduction.fulfilled, (state) => {
        state.preferences.userDismissedParkingIntroduction = true;
        state.isSaving = false;
      })
      .addCase(updateLicensePlate.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateLicensePlate.fulfilled, (state, action) => {
        state.preferences.licensePlate = action.payload;
        state.isSaving = false;
      })
      .addCase(updateLicensePlates.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateLicensePlates.fulfilled, (state, action) => {
        state.preferences.licensePlates = action.payload;
        state.isSaving = false;
      });

    builder
      .addCase(updateThreeDMapsPreferred.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateThreeDMapsPreferred.fulfilled, (state, action) => {
        state.preferences.threeDMapsPreferred = action.payload;
        state.isSaving = false;
      });
  },
});

export const preferencesReducer = preferencesSlice.reducer;
